import {
  API_ERROR,
  MENU_ITEMS,
  INPUT_CHANGEVALUE,
  SELECT_CHANGEVALUE,
  MENU_ITEMS_LIST_SUCCESSFUL,
  MENU_ITEMS_ADD,
  MENU_ITEMS_ADD_SUCCESSFUL,
  MENU_ITEMS_ROW_DATA,
  MENU_ITEMS_ROW_DATA_SUCCESSFUL,
  MENU_ITEMS_DELETE,
  MENU_ITEMS_SETROWDATA,
  MODEL_OPEN,
  MODEL_CLOSE,
  SET_PARAMS,
} from "./actionTypes";

const initialState = {
  error: "Sorry! No Data Found.",
  message: null,
  loading: false,
  MenuItemsList: [],
  model: false,
  error_msg: null,
  rowdata: {},
  params: {
    no_of_pages: 0,
    page_size: 10,
    page: 1,
    search: "",
    currentSort: "code",
    sortOrder: "-",
  },
};

const MenuItems = (state = initialState, action) => {
  switch (action.type) {
    case MENU_ITEMS:
      state = {
        ...state,
        loading: true,
      };
      break;
    case MENU_ITEMS_LIST_SUCCESSFUL:
      var noofpages = Math.ceil(
        action.payload.count / state.params.page_size
      );
      state = {
        ...state,
        MenuItemsList: action.payload.results,
        loading: false,
        params: {
          ...state.params,
          no_of_pages: noofpages,
        },
      };
      break;
    case INPUT_CHANGEVALUE:
      state = {
        ...state,
        rowdata: {
          ...state.rowdata,
          [action.payload.key]: action.payload.value,
        },
      };
      break;
    case SELECT_CHANGEVALUE:
      state = {
        ...state,
        rowdata: {
          ...state.rowdata,
          [action.payload.key]: action.payload.label,
          [action.payload.key2]: action.payload.value,
        },
      };
      break;
    case MENU_ITEMS_ADD:
      state = {
        ...state,
        loading: false,
      };
      break;
    case MENU_ITEMS_ADD_SUCCESSFUL:
      state = {
        ...state,
        // message: action.payload,
        loading: false,
        model: false,
        rowdata: { Id: 0 },
      };
      break;
    case MENU_ITEMS_ROW_DATA:
      state = {
        ...state,
        model: true,
        // rowdata: action.payload,
      };
      break;
    case MENU_ITEMS_ROW_DATA_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        rowdata: action.payload.response,
      };
      break;
    case MENU_ITEMS_DELETE:
      state = {
        ...state,
        loading: false,
      };
      break;
    case MENU_ITEMS_SETROWDATA:
      state = {
        ...state,
        rowdata: action.payload,
        // model: true,
      };
      break;
    case MODEL_OPEN:
      state = {
        ...state,
        model: true,
      };
      break;
    case MODEL_CLOSE:
      state = {
        ...state,
        model: false,
        rowdata: { id: 0 },
      };
      break;
    case SET_PARAMS:
      state = {
        ...state,
        params: action.payload,
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        loading: false,
        error_msg: action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default MenuItems;
